import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconSelectSingle(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M14 9H2v2h12V9Zm0-4H2v2h12V5ZM2 15h8v-2H2v2Zm19.5-4.5L23 12l-6.99 7-4.51-4.5L13 13l3.01 3 5.49-5.5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
